<script>
export default {
    name: "ArrowLeft"
}
</script>
<template>
    <svg role="img" aria-label="Arrow Left" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.713675 5.28368L-5.24537e-07 6L0.710531 6.71632L5.23782 11.2805L5.95149 12L7.37256 10.5642L6.66203 9.84786L3.85134 7.01426L12.9939 7.01426L14 7.01426L14 4.98574L12.9939 4.98574L3.85448 4.98574L6.66517 2.15214L7.37256 1.43582L5.95149 7.03623e-07L5.24096 0.716323L0.713675 5.28051L0.713675 5.28368Z" fill="#6B919B"/>
    </svg>
</template>
